import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import { IXGridBulkActionButton } from 'app/components/Common/XGrid/Toolbar/XGridToolbar';
import { GridApi } from '@mui/x-data-grid-pro';
import { TFunction } from 'i18next';
import { TagsManagementBulkTagsPickerHandle } from './TagsManagementBulkTagsPicker';

export const MAX_TAGS_CANDIDATE_SELECTION = 5;

export const getTagsCandidateSelectionWarning = (t: TFunction) =>
  t('tagsManagement.candidateTags.maxSelectionWarning', { count: MAX_TAGS_CANDIDATE_SELECTION });

export const limitTagsCandidateSelection = (
  selectedData: (string | number)[],
  apiRef: React.MutableRefObject<GridApi | undefined>,
): (string | number)[] => {
  if (selectedData.length <= MAX_TAGS_CANDIDATE_SELECTION) {
    return selectedData;
  }
  const limited = selectedData.slice(0, MAX_TAGS_CANDIDATE_SELECTION);
  apiRef.current?.setSelectionModel(limited);
  return limited;
};

export const buildTagsCandidateLeftActions = ({
  t,
  selectedCount,
  tagsPickerRef,
  toolbarButtonRef,
  limitSelectionOnExceed = true,
  idPrefix = 'tags-management',
}: {
  t: TFunction;
  selectedCount: number;
  tagsPickerRef: React.MutableRefObject<TagsManagementBulkTagsPickerHandle | null>;
  toolbarButtonRef: React.RefObject<HTMLElement>;
  /** When true (settings tab), selection is capped elsewhere; when false (global search), disable over max. */
  limitSelectionOnExceed?: boolean;
  idPrefix?: string;
}): IXGridBulkActionButton[] => [
  {
    id: `${idPrefix}-update-tags`,
    KeyId: `${idPrefix}-update-tags`,
    Icon: LocalOfferOutlinedIcon,
    title: 'tagsManagement.candidateTags.updateTags',
    disabled:
      selectedCount < 1 ||
      (!limitSelectionOnExceed && selectedCount > MAX_TAGS_CANDIDATE_SELECTION),
    leftDivider: limitSelectionOnExceed,
    buttonRef: toolbarButtonRef,
    onClick: () => tagsPickerRef.current?.open(),
    tooltipProps: {
      tooltipContent: getTagsCandidateSelectionWarning(t),
      disabled: limitSelectionOnExceed
        ? selectedCount <= MAX_TAGS_CANDIDATE_SELECTION
        : selectedCount <= MAX_TAGS_CANDIDATE_SELECTION,
    },
  },
];
